import {useQuery} from "@tanstack/react-query";
import {OrdersSearchParamType} from "../interface";
import {readShipmentList} from "../../../../../api/order/OrdersApi";
import {ordersListMapInit} from "../state";

type Props = {
    param: OrdersSearchParamType;
};

export const useReadShipmentList = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readShipmentList", param],
        queryFn: async () => await readShipmentList(param),
        select: (res) => res?.data.result ?? ordersListMapInit,
    });

    return {data};
};
